import { fetchRequestWithTypes } from './index.js';
import { BASE_LOGIN_URLS, CLIENT_IDS, REDIRECT_URLS } from '../../constants/authParams';

// The following is for local development only, and should never be triggered on a deployed environment
export const DEV_TOKEN_REQUEST = 'DEV_TOKEN_REQUEST';
export const DEV_TOKEN_SUCCESS = 'DEV_TOKEN_SUCCESS';
export const DEV_TOKEN_ERRORED = 'DEV_TOKEN_ERRORED';

export const devTokenRequest = (code) => {
	const STASH_ENV = '__STASH_ENV__';
	const clientId = CLIENT_IDS[STASH_ENV];
	const redirectUrl = REDIRECT_URLS[STASH_ENV];
	const basePath = BASE_LOGIN_URLS[STASH_ENV];

	return fetchRequestWithTypes({
		types: [DEV_TOKEN_REQUEST, DEV_TOKEN_SUCCESS, DEV_TOKEN_ERRORED],
		request: {
			method: 'POST',
			basePath,
			path: `/api/v1/token?grant_type=authorization_code&code=${code}&client_id=${clientId}&redirect_uri=${redirectUrl}`,
			headers: {
				Accept: 'application/json',
			},
		},
	});
};

export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_ERRORED = 'REFRESH_TOKEN_ERRORED';

export const refreshTokenRequest = (token) => {
	const STASH_ENV = window.Stash.env;
	const clientId = CLIENT_IDS[STASH_ENV];
	const redirectUrl = REDIRECT_URLS[STASH_ENV];
	const basePath = BASE_LOGIN_URLS[STASH_ENV];
	return fetchRequestWithTypes({
		types: [REFRESH_TOKEN_REQUEST, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_ERRORED],
		request: {
			method: 'POST',
			basePath,
			path: `/api/v1/token?grant_type=refresh_token&client_id=${clientId}&redirect_uri=${redirectUrl}`,
			headers: {
				Accept: 'application/json',
			},
			body: {
				refresh_token: token,
			},
		},
	});
};
